/* dd-new-quiz: quiz logic, result mapping and cart hand-off (section: sections/dd-new-quiz.liquid). Reads its config from the section's [data-nq-config] JSON. */
(function () {
  var DEFAULTS = {
    loadingSeconds: 5, pricePer1000: 9, kcalPerG: 1.35, bagG: 3175, ctaLabel: 'Checkout', defaultTier: 100, splitBags: 0, splitDays: 14, splitCadence: 'every 2 weeks',
    klaviyoKey: '', klaviyoList: '', klaviyoEvent: 'Quiz Completed',
    img: {}, a: {}, e: {}, o: {}, snacks: [], reviews: [], recipes: [],
    tiers: [
      { pct: 100, label: '100% \u00b7 All Fresh', desc: 'Every meal fresh.', badge: '' },
      { pct: 50, label: '50% \u00b7 Fresh Mix', desc: 'Mix fresh 50/50 with their dry food.', badge: 'Most Popular' },
      { pct: 25, label: '25% \u00b7 Fresh Booster', desc: 'Enjoy on top of kibble.', badge: '' }
    ],
    t: {
      badge: '', rating: '', title: '{n}\u2019s plan is ready.', subtitle: '', builtFor: 'Built to support {n}\u2019s {goal}',
      tiersHeading: 'How much of {n}\u2019s bowl should be fresh?', tiersSub: '',
      calc: 'At {pct}%, {n} eats {grams} of fresh a day \u00b7 {bags} {cadence}, pre-portioned.', calcSub: '',
      priceLine: '{price} a day to feed {n} at {pct}% fresh.', billing: 'Billed {cadence}. Cancel or skip whenever.', cadence: 'every 4 weeks',
      inlineCta: '', refund: '', recipeText: 'We\u2019d start {n} on {recipe}. You can switch any time, or rotate.', seeAll: 'See all recipes',
      offer: '', whyHeading: 'Why {n} will love this', why5: '', why6: ''
    }
  };
  var BLANK_RECIPE = { id: '', role: 'standard', name: '', desc: '', proteins: '', url: '', variant: null, available: true,
    fullPrice: null, bagPrice: null, sellingPlan: null, sellingPlan2: null, bagPrice2: null, img: null, rating: null, reviews: null, nutrition: null, ingredients: [] };

  /* Config comes from the section's JSON script. Anything missing or invalid falls back to DEFAULTS. */
  function readConfig(root) {
    var el = root.querySelector('[data-nq-config]'), raw = {};
    try { raw = JSON.parse(el.textContent) || {}; } catch (e) { console.warn('dd-new-quiz: invalid config JSON', e); }
    var C = {};
    Object.keys(DEFAULTS).forEach(function (k) { C[k] = raw[k] != null ? raw[k] : DEFAULTS[k]; });
    C.splitBags = Number(C.splitBags) > 0 ? Number(C.splitBags) : 0;
    ['loadingSeconds', 'pricePer1000', 'kcalPerG', 'bagG', 'splitDays'].forEach(function (k) {
      var n = Number(C[k]);
      C[k] = n > 0 ? n : DEFAULTS[k];
    });
    C.img = C.img || {};
    C.a = Object.assign({ icons: {} }, raw.a || {});
    C.e = Object.assign({ title: 'Let\u2019s find their kind of bowl.', text: '', button: 'Start the quiz', badge: '', promo: '', storeHref: '', loadingOffer: '', loadingButton: 'Discount secured' }, raw.e || {});
    C.reviews = Array.isArray(raw.reviews) ? raw.reviews : [];
    C.snacks = Array.isArray(raw.snacks) ? raw.snacks.filter(function (x) { return x && x.variant; }) : [];
    C.o = Object.assign({ title: '{n}\u2019s plan', line1: '{pct}% fresh, {recipe}, {grams}g/day', line2: '{bags} bags, delivered {cadence}.', planLabel: 'Plan',
      discountLabel: 'First-order discount', shippingLabel: 'Shipping', shippingValue: 'Free', totalLabel: 'Total today', guarantee: '', note: '', nextTitle: 'What happens next',
      next1: '', next2: '', shipDays: 2, arriveDays: 5, cadenceDays: 28, backLabel: 'Go back and change something', snacksTitle: 'Want to add snacks to {n}\u2019s plan?',
      snacksText: '', snacksNote: '', viewDetails: 'View details' }, raw.o || {});
    C.t = Object.assign({}, DEFAULTS.t, raw.t || {});
    C.tiers = Array.isArray(raw.tiers) && raw.tiers.length ? raw.tiers : DEFAULTS.tiers;
    /* preselected fresh % on the results screen; must match one of the tiers */
    C.defaultTier = Number(C.defaultTier);
    if (!C.tiers.some(function (t) { return t.pct === C.defaultTier; })) C.defaultTier = DEFAULTS.defaultTier;
    C.recipes = (Array.isArray(raw.recipes) ? raw.recipes : []).map(function (r) { return Object.assign({}, BLANK_RECIPE, r); });
    if (!C.recipes.length) C.recipes.push(Object.assign({}, BLANK_RECIPE, { id: 'none', role: 'default', name: 'Fresh recipe',
      desc: 'Add recipe blocks in the section settings.', available: false }));
    return C;
  }

  function init(root) {
  if (root.dataset.nqInit) return;
  root.dataset.nqInit = '1';
  var C = readConfig(root);
  if (!C) return;
  var $ = function (s) { return root.querySelector(s); };
  var body = $('[data-nq-body]'), head = $('[data-nq-head]'), foot = $('[data-nq-foot]');
  var cta = $('[data-nq-cta]'), errEl = $('[data-nq-err]'), priceEl = $('[data-nq-price]'), noteEl = $('[data-nq-note]');
  var cardEl = $('.dd-nq__card'), qfootEl = $('[data-nq-qfoot]');

  var FLOW = ['name', 'age', 'sex', 'fixed', 'weight', 'body', 'energy', 'avoid', 'goals'];
  var PER = FLOW.slice(1);
  var ORDER = ['entry'].concat(FLOW, ['email', 'loading', 'results', 'order']);
  var KEY = 'dd-new-quiz-v1', MAX_PUPS = 4;
  var PUP = { name: '', years: '', months: '', sex: null, fixed: null, weight: '', body: null, energy: null, avoid: [], goals: [], tier: C.defaultTier, recipe: null };
  var OPTS = {
    sex: [{ id: 'male', label: 'Male' }, { id: 'female', label: 'Female' }],
    fixed: [{ id: 'yes', label: 'Yes' }, { id: 'no', label: 'No' }],
    body: [
      { id: 'lean', label: 'A little lean', desc: 'Ribs and hip bones easy to see.', img: C.img.lean || C.a.bodyLean },
      { id: 'right', label: 'Looking just right', desc: 'Ribs easy to feel, visible waist from above.', img: C.img.right || C.a.bodyRight },
      { id: 'extra', label: 'A little extra to love', desc: 'Ribs hard to feel, no clear waist.', img: C.img.extra || C.a.bodyExtra }],
    energy: [
      { id: 'lounge', label: 'Lounge life', desc: 'Short walks, long naps.' },
      { id: 'explorer', label: 'Everyday explorer', desc: 'Regular walks and a little play.' },
      { id: 'zoomie', label: 'Zoomie mode', desc: 'Runs, hikes, always on.' }],
    avoid: [
      { id: 'chicken', label: 'Chicken' }, { id: 'beef', label: 'Beef' }, { id: 'fish', label: 'Fish' },
      { id: 'pork', label: 'Pork' }, { id: 'turkey', label: 'Turkey' }, { id: 'grain', label: 'Grain' },
      { id: 'none', label: 'Nothing that we know of', full: true }],
    goals: [
      { id: 'picky', label: 'Food a picky eater actually loves', phrase: 'picky eaters' },
      { id: 'tummy', label: 'A calmer, happier tummy', phrase: 'a sensitive tummy' },
      { id: 'skin', label: 'Itchy skin and a healthier coat', phrase: 'skin and coat health' },
      { id: 'weight', label: 'A healthier weight', phrase: 'a healthier weight' },
      { id: 'better', label: 'Just want to feed better', phrase: 'everyday feeding' }]
  };
  var MULTI = { avoid: 1, goals: 1 };
  var TIERS = C.tiers, T = C.t, extra = $('[data-nq-extra]');
  var RECIPES = C.recipes.map(function (r) {
    r.proteins = (r.proteins || '').split(',').map(function (x) { return x.trim(); }).filter(Boolean);
    return r;
  });
  var EMAIL_RX = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  var S = { screen: 'entry', pups: [clone(PUP)], active: 0, email: '', sent: '', swap: false, info: null, snacks: {}, progress: 0, err: '' };
  try {
    var saved = JSON.parse(localStorage.getItem(KEY) || 'null');
    if (saved && saved.pups && saved.pups.length) {
      S.pups = saved.pups; S.email = saved.email || ''; S.sent = saved.sent || ''; S.snacks = saved.snacks || {};
      S.screen = ORDER.indexOf(saved.screen) > -1 ? saved.screen : 'entry';
    }
  } catch (e) {}
  if (S.screen === 'loading') S.screen = 'email';

  function clone(o) { return JSON.parse(JSON.stringify(o)); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function money(n) { return '$' + (Math.round(n * 100) / 100).toFixed(2); }
  function persist() { try { localStorage.setItem(KEY, JSON.stringify({ screen: S.screen, pups: S.pups, email: S.email, sent: S.sent, snacks: S.snacks })); } catch (e) {} }
  function pupName(p, i) { return p.name.trim() || 'Pup ' + (i + 1); }
  function joinNames(a) { return a.length < 2 ? (a[0] || '') : a.slice(0, -1).join(', ') + ' and ' + a[a.length - 1]; }
  function names() { return S.pups.map(pupName); }
  function ageOf(p) { return Number(p.years || 0) + Number(p.months || 0) / 12; }
  function fixWord(p) { return p.sex === 'female' ? 'spayed' : p.sex === 'male' ? 'neutered' : 'spayed / neutered'; }

  function pupError(p, scr) {
    switch (scr) {
      case 'name': return p.name.trim() ? null : 'name';
      case 'age':
        var y = Number(p.years || 0), m = Number(p.months || 0);
        if (y < 0 || y > 25 || m < 0 || m > 300 || y + m / 12 > 25) return 'a valid age';
        return (y + m) > 0 ? null : 'age';
      case 'weight': var w = Number(p.weight); return w >= 1 && w <= 250 ? null : 'weight (1 to 250 lbs)';
      case 'avoid': case 'goals': return p[scr].length ? null : 'answer';
      case 'sex': case 'fixed': case 'body': case 'energy': return p[scr] ? null : 'answer';
    }
    return null;
  }
  function validate() {
    if (S.screen === 'email') return EMAIL_RX.test(S.email.trim()) ? null : 'That email doesn’t look quite right.';
    if (PER.indexOf(S.screen) < 0 && S.screen !== 'name') return null;
    var multi = S.pups.length > 1;
    for (var i = 0; i < S.pups.length; i++) {
      var e = pupError(S.pups[i], S.screen);
      if (!e) continue;
      if (S.screen === 'name') return multi ? 'Add a name for pup ' + (i + 1) + '.' : 'Tell us their name to continue.';
      var nm = pupName(S.pups[i], i);
      if (e === 'answer') return multi ? 'Pick an answer for ' + nm + '.' : 'Pick one to continue.';
      return 'Add ' + (multi ? nm + '’s ' : 'their ') + e + '.';
    }
    return null;
  }

  /* ---- portion math (tune in section settings) ----
     kcal/day = 70 x m x kg^0.75, with one multiplier m (client spec, Oct 2026):
     puppies (under 1 year) by age: 1-3 months 3, 4-6 months 2.5, 7-12 months 2.
     adults + seniors by spay/neuter and activity; "a little extra" body condition uses 1 whatever the activity. */
  var M_ADULT = { yes: { lounge: 1.2, explorer: 1.4, zoomie: 1.6 }, no: { lounge: 1.4, explorer: 1.6, zoomie: 1.8 } };
  function multiplier(p) {
    var mo = Number(p.years || 0) * 12 + Number(p.months || 0);
    if (mo > 0 && mo < 12) return mo <= 3 ? 3 : mo <= 6 ? 2.5 : 2;
    if (p.body === 'extra') return 1;
    var row = M_ADULT[p.fixed === 'no' ? 'no' : 'yes'];
    return row[p.energy] || row.explorer;
  }
  function calc(p, pct) {
    var lbs = Number(p.weight) || 40, kg = lbs * 0.453592;
    var kcal = Math.round(70 * multiplier(p) * Math.pow(kg, 0.75)), fresh = Math.round(kcal * pct / 100);
    var grams = Math.round(fresh / C.kcalPerG), r = recipeFor(p).recipe;
    /* big orders (more than splitBags bags per 4 weeks) ship more often with fewer bags per box, if that selling plan exists */
    var bags = Math.max(1, Math.ceil(grams * 28 / C.bagG)), days = 28, plan = r && r.sellingPlan, price = r && r.bagPrice, cadence = T.cadence;
    if (C.splitBags && bags > C.splitBags && r && r.sellingPlan2) {
      days = C.splitDays; bags = Math.max(1, Math.ceil(grams * days / C.bagG)); plan = r.sellingPlan2; price = r.bagPrice2 || r.bagPrice; cadence = C.splitCadence;
    }
    var perDay = price ? bags * price / days : fresh / 1000 * C.pricePer1000;
    return { fresh: fresh, grams: grams, bags: bags, days: days, plan: plan, price: price, cadence: cadence, perDay: perDay };
  }

  /* ---- result mapping: quiz answers -> recipe block -> product ---- */
  function recipeFor(p) {
    var avoided = p.avoid.filter(function (a) { return a !== 'none'; });
    function allowed(r) { return !r.proteins.some(function (x) { return avoided.indexOf(x) > -1; }); }
    function byRole(role) { return RECIPES.filter(function (r) { return r.role === role; }); }
    var age = ageOf(p), rec = null;
    if (age > 0 && age < 1) rec = byRole('puppy').filter(allowed)[0];
    if (!rec) rec = byRole('default').filter(allowed)[0];
    if (!rec) rec = byRole('standard').filter(allowed)[0];
    if (!rec) rec = RECIPES.filter(allowed)[0] || RECIPES[0];
    var picked = RECIPES.filter(function (r) { return r.id === p.recipe; })[0];
    return { recipe: picked && allowed(picked) ? picked : rec, rec: rec, allowed: allowed, avoided: avoided };
  }

  /* ---- render ---- */
  function go(scr) {
    clearInterval(S.iv); clearTimeout(S.to);
    S.screen = scr; S.err = ''; S.swap = false; S.info = null; S.tip = false; persist(); render();
    var top = root.getBoundingClientRect().top;
    if (top < 0) window.scrollTo({ top: window.pageYOffset + top - 80 });
    if (scr === 'loading') startLoading();
  }
  function fmt(s) {
    return esc(s).replace(/\[\[(.+?)\]\]/g, '<u>$1</u>').replace(/\{\{(.+?)\}\}/g, '<em>$1</em>').replace(/\n/g, '<br>');
  }
  function qHead(t, reason, extra) {
    return '<div class="dd-nq__q"><h2 class="dd-nq__title">' + fmt(t) + '</h2>' +
      (reason ? '<p class="dd-nq__reason">' + fmt(reason) + '</p>' : '') + (extra || '') + '</div>';
  }
  /* One question screen: copy on the left (desktop) / top (mobile), answers + Continue on the right / below.
     [data-nq-host] is where render() moves the Continue holder. */
  function qWrap(scr, q, inner, link, qExtra) {
    return '<div class="dd-nq__qwrap dd-nq__qwrap--' + scr + (S.pups.length > 1 && PER.indexOf(scr) > -1 ? ' dd-nq__qwrap--multi' : '') + '">' + qHead(q[0], q[1], qExtra) +
      '<div class="dd-nq__right"><div class="dd-nq__fields">' + inner + '</div>' + (link || '') + '<div class="dd-nq__host" data-nq-host></div></div></div>';
  }
  function questionText() {
    var multi = S.pups.length > 1, list = joinNames(names()), nm = names()[0];
    return {
      name: [multi ? "What are your pups' names?" : "What's your pup's name?", "We're building this just for them, so let's make it personal."],
      age: [multi ? 'How old are ' + list + '?' : 'How old is ' + nm + '?', 'Age helps us match their meals to their stage, from puppy zoomies to senior strolls.'],
      sex: ['Tell us about ' + list, 'A few basics help us recommend the right daily calories for their bowl.'],
      fixed: [multi ? 'Are ' + list + ' spayed / neutered?' : 'Is ' + nm + ' spayed / neutered?', 'A few basics help us recommend the right daily calories for their bowl.'],
      weight: [multi ? 'What does each pup weigh right now?' : "What's " + nm + "'s current weight?", 'A quick weigh-in helps us serve up the right daily portion.'],
      body: [multi ? 'How are ' + list + ' looking these days?' : 'How is ' + nm + ' looking these days?', 'Every pup carries weight a little differently, so this helps us fine-tune their bowl.'],
      energy: ['What kind of energy are we feeding?', 'Loungers, walkers, and nonstop zoomers all need different fuel.'],
      avoid: ['Is there anything ' + list + ' should [[avoid]]?', "Pick anything they {{avoid}}, and we'll keep it out of their recommended recipes.\n\n{{Pick all that apply.}}"],
      goals: ['What matters most for ' + list + '?', 'This is the one we build everything else around.'],
      email: ['Save ' + list + '’s personalized plan.', 'Enter your email and we’ll send a copy of ' + list + '’s plan to your inbox.']
    };
  }

  function render() {
    var scr = S.screen, idx = FLOW.indexOf(scr);
    root.setAttribute('data-nq-screen', scr);
    document.documentElement.setAttribute('data-nq-screen', scr);
    /* website header: visible on the entry screen only (theme.liquid hides it while this class is on <html>) */
    document.documentElement.classList.toggle('dd-nq-flow', scr !== 'entry');
    head.hidden = scr === 'entry';
    if (!head.hidden) {
      $('[data-nq-bar]').style.width = (idx >= 0 ? (idx + 1) / FLOW.length * 100 : 100) + '%';
      $('[data-nq-step]').textContent = idx >= 0 ? 'Step ' + (idx + 1) + ' of ' + FLOW.length : scr === 'email' ? 'Last step' : scr === 'loading' ? 'Almost there' : 'Results';
    }
    foot.hidden = scr === 'loading' || scr === 'entry' || scr === 'results' || scr === 'order'; extra.hidden = true;
    noteEl.hidden = scr !== 'email';
    /* park the Continue holder before the screen markup is replaced */
    if (qfootEl.parentNode === cardEl) cardEl.insertBefore(foot, qfootEl); else cardEl.appendChild(foot);
    if (scr === 'entry') body.innerHTML = viewEntry();
    else if (scr === 'name') body.innerHTML = viewName();
    else if (PER.indexOf(scr) > -1) body.innerHTML = viewPer(scr);
    else if (scr === 'email') body.innerHTML = viewEmail();
    else if (scr === 'loading') body.innerHTML = viewLoading();
    else if (scr === 'order') body.innerHTML = viewOrder();
    else body.innerHTML = viewResults();
    var host = body.querySelector('[data-nq-host]');
    if (host) host.appendChild(foot);
    Array.prototype.forEach.call(document.querySelectorAll('a[href="#nq-checkout"]'), function (a) { a.textContent = scr === 'order' ? C.ctaLabel : (T.inlineCta || 'Checkout'); });
    updateFoot();
  }

  /* offer badge: the first two words are the headline ("30% off"), the rest the small line */
  function offerBadge(s) {
    var m = String(s).trim().match(/^(\S+\s+\S+)\s+(.+)$/);
    return '<p class="dd-nq__obadge">' + (m ? '<b>' + esc(m[1]) + '</b><span>' + esc(m[2]) + '</span>' : '<b>' + esc(s) + '</b>') + '</p>';
  }
  function viewEntry() {
    var E = C.e, A = C.a, badge = E.promo ? offerBadge(E.promo) : '';
    return '<div class="dd-nq__entry"><div class="dd-nq__ent-main"><div class="dd-nq__ent-copy"><div class="dd-nq__ent-txt"><h2 class="dd-nq__ent-t">' + esc(E.title) + '</h2>' +
      (E.text ? '<p class="dd-nq__ent-p">' + esc(E.text) + '</p>' : '') + '<button type="button" class="dd-nq__cta dd-nq__cta--auto" data-start>' + esc(E.button) + '</button></div></div>' +
      (A.entry ? '<div class="dd-nq__ent-img"><img src="' + esc(A.entry) + '" alt="">' + badge + '</div>' : badge) + '</div></div>';
  }

  function viewName() {
    var q = questionText().name, multi = S.pups.length > 1;
    var rows = S.pups.map(function (p, i) {
      return '<div>' + (multi ? '<div class="dd-nq__lbl"><span>Pup ' + (i + 1) + '</span>' + (i > 0 ? '<button type="button" data-rm="' + i + '">Remove</button>' : '') + '</div>' : '') +
        '<input type="text" class="dd-nq__in" data-name="' + i + '" value="' + esc(p.name) + '" placeholder="' + (multi ? 'Pup ' + (i + 1) + ' name' : 'Name') + '" aria-label="' + (multi ? 'Pup ' + (i + 1) + ' name' : 'Name') + '" autocomplete="off"></div>';
    }).join('');
    var link = S.pups.length < MAX_PUPS ? '<button type="button" class="dd-nq__link" data-add>' + (multi ? '+ Add another pup' : 'I have more than one PUP') + '</button>' : '';
    return qWrap('name', q, rows, link);
  }

  function bodyImg(o) {
    return o.img ? '<img src="' + esc(o.img) + '" alt="" loading="lazy">' : '';
  }

  function viewPer(scr) {
    var q = questionText()[scr], multi = S.pups.length > 1, nms = names(), A = C.a;
    var blocks = S.pups.map(function (p, i) {
      var h = multi ? '<div class="dd-nq__pup-h"><b>' + esc(nms[i].charAt(0).toUpperCase()) + '</b><span>' + esc(nms[i]) + '</span>' +
        (scr === 'fixed' ? '<em>' + fixWord(p) + '?</em>' : '') + '<i></i></div>' : '';
      var inner = '';
      if (scr === 'age') {
        /* years and months are both always there; fill either or both */
        inner = '<div class="dd-nq__age">' + [['years', 'Years', 25], ['months', 'Months', 300]].map(function (u) {
          return '<div class="dd-nq__field"><input type="number" inputmode="numeric" min="0" max="' + u[2] + '" step="1" data-f="' + u[0] + '" data-i="' + i + '" value="' + esc(p[u[0]]) + '" placeholder="0" aria-label="Age in ' + u[0] + '"><div class="dd-nq__unit"><span>' + u[1] + '</span></div></div>';
        }).join('') + '</div>';
      } else if (scr === 'weight') {
        inner = '<div class="dd-nq__field"><input type="number" inputmode="decimal" min="1" max="250" data-f="weight" data-i="' + i + '" value="' + esc(p.weight) + '" placeholder="20" aria-label="Weight in pounds"><div class="dd-nq__unit"><span>lbs</span></div></div>';
      } else {
        var multiSel = !!MULTI[scr];
        inner = '<div class="dd-nq__opts' + (scr === 'sex' || scr === 'fixed' ? ' dd-nq__opts--2' : scr === 'avoid' ? ' dd-nq__opts--avoid' : '') + '">' + OPTS[scr].map(function (o) {
          var on = multiSel ? p[scr].indexOf(o.id) > -1 : p[scr] === o.id, content;
          if (scr === 'body') content = bodyImg(o) + '<b>' + esc(o.label) + '</b>';
          else if (scr === 'energy') content = '<span class="dd-nq__opt-t"><b>' + esc(o.label) + '</b>' + (o.desc ? '<span>' + esc(o.desc) + '</span>' : '') + '</span>';
          else if (scr === 'avoid') content = (A.icons && A.icons[o.id] ? '<img class="dd-nq__ic' + (o.id === 'grain' ? ' dd-nq__ic--grain' : '') + '" src="' + esc(A.icons[o.id]) + '" alt="">' : '') + '<b>' + esc(o.label) + '</b>';
          else content = '<b>' + esc(o.label) + '</b>';
          return '<button type="button" class="dd-nq__opt dd-nq__opt--' + scr + (on ? ' is-on' : '') + (o.full ? ' dd-nq__opt--full' : '') + '" data-pick="' + o.id + '" data-i="' + i + '" aria-pressed="' + on + '">' + content + '</button>';
        }).join('') + '</div>';
      }
      return '<div class="dd-nq__pup">' + h + inner + '</div>';
    }).join('');
    var qExtra = '';
    if (scr === 'body') {
      qExtra = '<div class="dd-nq__tipwrap"><button type="button" class="dd-nq__link" data-tip aria-expanded="' + !!S.tip + '">Not sure how to tell?</button>' +
        (S.tip ? '<div class="dd-nq__tip" role="tooltip">' + OPTS.body.map(function (o) { return esc(o.label + ': ' + o.desc); }).join('<br>') + '</div>' : '') + '</div>';
    }
    return qWrap(scr, q, blocks, '', qExtra);
  }
  function viewEmail() {
    var q = questionText().email;
    return qWrap('email', q, '<input type="email" class="dd-nq__in dd-nq__in--l" data-email value="' + esc(S.email) + '" placeholder="Email" aria-label="Email" autocomplete="email">');
  }
  function reviewCard(r) {
    return '<div class="dd-nq__rev"><div class="dd-nq__rev-q">“' + esc(r.quote) + '”</div><div class="dd-nq__rev-by">' +
      (r.img ? '<img src="' + esc(r.img) + '" alt="">' : '') + '<span>' + esc(r.name) + '</span><span class="dd-nq__rev-s" style="margin-left:auto">★★★★★</span></div></div>';
  }
  var RING = 523.07; /* 2 * pi * 83.25 */
  function viewLoading() {
    var list = joinNames(names()), his = S.pups.length > 1 ? 'their' : (S.pups[0].sex === 'female' ? 'her' : 'his');
    var t = ['Picking recipes ' + list + ' will love', 'Matching recipes to ' + his + ' needs', 'Customizing ' + his + ' caloric needs'];
    var cards = C.reviews.slice(0, 2).map(reviewCard).join('');
    return '<div class="dd-nq__load"><div class="dd-nq__load-in"><div class="dd-nq__ring" data-ringwrap><svg viewBox="0 0 180 180" aria-hidden="true"><circle cx="90" cy="90" r="83.25" fill="none" stroke="#76D4B2" stroke-width="13.5"/>' +
      '<circle data-ring cx="90" cy="90" r="83.25" fill="none" stroke="#178468" stroke-width="13.5" stroke-dasharray="' + RING + '" stroke-dashoffset="' + RING + '" transform="rotate(-90 90 90)"/></svg><div class="dd-nq__ring-t" data-pct>0%</div></div>' +
      '<div class="dd-nq__load-col"><div class="dd-nq__lines">' +
      t.map(function (x) { return '<div class="dd-nq__line"><i></i><span>' + esc(x) + '</span></div>'; }).join('') + '</div>' +
      '<div class="dd-nq__done" data-nq-done hidden>' + (C.e.loadingOffer ? '<p class="dd-nq__load-offer">' + esc(C.e.loadingOffer) + '</p>' : '') +
      '<button type="button" class="dd-nq__cta" data-go-results>' + esc(C.e.loadingButton || 'Continue') + '</button></div>' +
      (cards ? '<div class="dd-nq__load-h">While we build it,<br>what other dog parents said</div><div class="dd-nq__load-cards">' + cards + '</div>' : '') + '</div></div></div>';
  }
  function startLoading() {
    var secs = Math.max(1, Number(C.loadingSeconds) || 5), step = 100 / (secs * 1000 / 60), p = 0;
    var ring = $('[data-ring]'), pct = $('[data-pct]'), lines = root.querySelectorAll('.dd-nq__line'), A = C.a;
    S.iv = setInterval(function () {
      p = Math.min(100, p + step);
      ring.setAttribute('stroke-dashoffset', RING * (1 - p / 100));
      pct.textContent = Math.round(p) + '%';
      Array.prototype.forEach.call(lines, function (l, i) {
        var done = p >= (i + 1) * 33.3, act = !done && p >= i * 33.3, st = done ? 'd' : act ? 'a' : 'w';
        if (l.getAttribute('data-s') === st) return;
        l.setAttribute('data-s', st);
        l.classList.toggle('is-done', done); l.classList.toggle('is-act', act);
        l.firstChild.innerHTML = done && A.yes ? '<img src="' + esc(A.yes) + '" alt="">' : '';
      });
      if (p >= 100) {
        clearInterval(S.iv);
        var wrap = $('[data-ringwrap]'); if (wrap && A.ringDone) wrap.innerHTML = '<img src="' + esc(A.ringDone) + '" alt="">';
        var dn = $('[data-nq-done]'); if (dn) dn.hidden = false;
        Array.prototype.forEach.call(lines, function (l) { l.classList.add('is-done'); l.classList.remove('is-act'); if (A.yes) l.firstChild.innerHTML = '<img src="' + esc(A.yes) + '" alt="">'; });
        S.to = setTimeout(function () { go('results'); }, 5000); /* show the "discount secured" state for 5 seconds, then move on */
      }
    }, 60);
  }

  function tok(str, v) {
    return String(str || '').replace(/\{(\w+)\}/g, function (m, k) { return v[k] != null ? v[k] : m; });
  }

  /* ---- results reveal + cart (Figma 13 / 14) ---- */
  var STRIP = ['100% Human Grade', '90% Protein + 10% Veggies', 'Made with Bone Broth', 'Transparent Farm to Bowl', 'Vet-Formulated'];
  var STRIP_SECS = 30; /* keep in sync with .dd-nq__strip-t animation duration */
  /* scrolling marquee like the homepage one: two copies of the list, the track slides by half its width */
  function stripHtml() {
    var group = function (dup) {
      return '<ul class="dd-nq__strip-g"' + (dup ? ' aria-hidden="true"' : '') + '>' + STRIP.map(function (x) { return '<li>' + esc(x) + '</li><li class="dd-nq__strip-dot" aria-hidden="true">•</li>'; }).join('') + '</ul>';
    };
    /* render() rebuilds the screen on every click: a clock-based negative delay keeps the scroll position instead of restarting it */
    var delay = -(Date.now() / 1000 % STRIP_SECS).toFixed(2);
    return '<div class="dd-nq__strip"><div class="dd-nq__strip-t" style="animation-delay:' + delay + 's">' + group(false) + group(true) + '</div></div>';
  }
  function headHtml(title, extraHtml) {
    var A = C.a;
    return '<div class="dd-nq__rhead"><div class="dd-nq__rate2">' + (A.starsWhite ? '<img src="' + esc(A.starsWhite) + '" alt="" width="80" height="12">' : '') +
      '<span>' + esc(T.badge || '4M+ Meals Served') + '</span></div><h2 class="dd-nq__rtitle">' + esc(title) + '</h2>' + extraHtml + '</div>';
  }
  function accRow(key, label, body, open) {
    return '<div class="dd-nq__acc' + (open ? ' is-open' : '') + '"><button type="button" class="dd-nq__acc-h" data-info="' + key + '" aria-expanded="' + !!open + '"><span>' + label + '</span>' +
      (C.a.chev ? '<img src="' + esc(C.a.chev) + '" alt="">' : '') + '</button>' + (open ? '<div class="dd-nq__acc-b">' + body + '</div>' : '') + '</div>';
  }
  function infoBlock(r) {
    var hasIng = r.ingredients && r.ingredients.length, hasNut = !!r.nutrition, out = '';
    if (hasIng) out += accRow('ing', 'Ingredients', r.ingredients.map(function (x) { return '<p><b>' + esc(x.name) + '</b>' + (x.text ? ' — ' + esc(x.text) : '') + '</p>'; }).join(''), S.info === 'ing');
    if (hasNut) out += accRow('nut', 'Nutritional Info', '<img src="' + esc(r.nutrition) + '" alt="' + esc(r.name) + ' nutrition facts" loading="lazy">', S.info === 'nut');
    return out ? '<div class="dd-nq__accs">' + out + '</div>' : '';
  }

  function viewResults() {
    var ai = Math.min(S.active, S.pups.length - 1), P = S.pups[ai], nms = names(), nm = nms[ai], multi = S.pups.length > 1, A = C.a;
    var R = recipeFor(P), r = R.recipe, c = calc(P, P.tier);
    var goal0 = OPTS.goals.filter(function (g) { return g.id === P.goals[0]; })[0];
    var Ptm = Math.round(Number(P.years || 0) * 12 + Number(P.months || 0)), Py = Math.floor(Ptm / 12), Pm = Ptm % 12, Pa = ageOf(P), his = P.sex === 'female' ? 'her' : 'his';
    var ageText = Pa > 0 ? (Py >= 1 ? Py + ' year' + (Py === 1 ? '' : 's') : Pm + ' month' + (Pm === 1 ? '' : 's')) + ' old' : 'their age';
    var energy = { lounge: 'a lounge-life pup', explorer: 'an everyday explorer', zoomie: 'a pup in zoomie mode' }[P.energy] || 'your kind of pup';
    var why = ['Made for pups that are ' + ageText + '.', 'Ingredients formulated with ' + (goal0 ? goal0.phrase : 'everyday feeding') + ' in mind.',
      'Made for ' + energy + '.', 'Pre-portioned to ' + his + ' target weight, so nobody is guessing at the scoop.'];
    if (T.why5) why.push(T.why5.replace(/\{n\}/g, nm));
    if (T.why6) why.push(T.why6.replace(/\{n\}/g, nm));
    var vars = { n: nm, pct: P.tier, goal: goal0 ? goal0.phrase : 'everyday feeding', recipe: r.name, cadence: c.cadence };
    var calcHtml = esc(tok(T.calc, vars)).replace('{grams}', '<b>' + c.grams + ' g</b>').replace('{bags}', '<b>' + c.bags + ' x 7lb bags</b>').replace('{kcal}', '<b>' + c.fresh + ' kcal</b>');
    var tabs = multi ? '<div class="dd-nq__tabs">' + S.pups.map(function (p, i) { return '<button type="button" class="dd-nq__tab' + (i === ai ? ' is-on' : '') + '" data-tab="' + i + '">' + esc(nms[i]) + '</button>'; }).join('') + '</div>' +
      '<div class="dd-nq__note-c">Each pup gets their own portion, recipe and fresh amount. Switch pups to set each one.</div>' : '';
    var swap = S.swap ? '<div class="dd-nq__swap">' + RECIPES.map(function (x) {
      var ok = R.allowed(x), hit = x.proteins.filter(function (y) { return R.avoided.indexOf(y) > -1; });
      return '<button type="button" data-recipe="' + esc(x.id) + '"' + (ok ? '' : ' disabled') + ' class="' + (x.id === r.id ? 'is-on' : '') + '"><span><b>' + esc(x.name) + '</b><small>' +
        esc(!ok ? 'Contains ' + hit.join(', ') : x.id === R.rec.id ? 'Recommended for ' + nm : x.desc.replace(/\{n\}/g, nm)) + '</small></span><span>' + (x.id === r.id ? '✓' : '') + '</span></button>';
    }).join('') + '</div>' : '';
    var perks = [[A.perkSale, 'Save 5% Every Month + Free Shipping'], [A.perkAward, '100% Satisfaction Guarantee'], [A.perkX, 'Pause, Skip or Cancel Anytime']];
    var left = '<div class="dd-nq__rleft"><div class="dd-nq__rname"><h3>' + esc(r.name) + '</h3>' + (r.desc ? '<p>' + esc(String(r.desc).replace(/\{n\}/g, nm)) + '</p>' : '') + '</div>' +
      (r.img ? '<div class="dd-nq__rimg"><img src="' + esc(r.img) + '" alt="' + esc(r.name) + '"></div>' : '') + infoBlock(r) + '</div>';
    var right = '<div class="dd-nq__rtiers"><h3 class="dd-nq__tiers-h">' + esc(tok(T.tiersHeading, vars)) + '</h3><div class="dd-nq__tl">' + TIERS.map(function (t) {
        var on = P.tier === t.pct;
        return '<button type="button" class="dd-nq__topt' + (on ? ' is-on' : '') + '" data-tier="' + t.pct + '" aria-pressed="' + on + '">' + (t.badge ? '<span class="dd-nq__tbadge">' + esc(t.badge) + '</span>' : '') +
          '<span class="dd-nq__topt-t"><b>' + esc(t.label) + '</b><span>' + esc(tok(t.desc, vars)) + '</span></span><span class="dd-nq__topt-p">' + money(calc(P, t.pct).perDay) + '/day</span></button>';
      }).join('') + '</div><p class="dd-nq__calc2">' + calcHtml + '</p>' +
      '<button type="button" class="dd-nq__cta" data-order>' + esc(T.inlineCta || 'Checkout') + '</button>' +
      (T.offer ? '<p class="dd-nq__offer">' + fmt(T.offer) + '</p>' : '') +
      '<div class="dd-nq__why2"><h3>' + esc(tok(T.whyHeading, vars)) + '</h3><ul>' + why.map(function (w) { return '<li>' + (A.bullet ? '<img src="' + esc(A.bullet) + '" alt="">' : '') + '<span>' + esc(w) + '</span></li>'; }).join('') + '</ul></div>' +
      '<ul class="dd-nq__perks">' + perks.map(function (x) { return '<li>' + (x[0] ? '<img src="' + esc(x[0]) + '" alt="">' : '') + '<span>' + esc(x[1]) + '</span></li>'; }).join('') + '</ul></div>';
    return '<div class="dd-nq__rtop">' + headHtml(tok(T.title, { n: multi ? joinNames(nms) : nm }),
      tabs + '<button type="button" class="dd-nq__rlink" data-swap>' + esc(S.swap ? 'Close' : 'Change your recipe.') + '</button>' + swap) +
      '<div class="dd-nq__rbody">' + left + right + '</div></div>' + stripHtml();
  }

  function fmtDate(d) { try { return d.toLocaleDateString(undefined, { weekday: 'short', month: 'short', day: 'numeric' }); } catch (e) { return d.toDateString(); } }
  function addDays(d, n) { var x = new Date(d.getTime()); x.setDate(x.getDate() + n); return x; }
  function orderTotals() {
    var lines = S.pups.map(function (p, i) {
      var r = recipeFor(p).recipe, c = calc(p, p.tier);
      var full = r.fullPrice ? c.bags * r.fullPrice : c.perDay * c.days;
      var paid = c.price ? c.bags * c.price : full;
      if (c.plan) paid = Math.round(full * 0.7 * 100) / 100; /* QUIZ30: first subscription order is 30% off in total, applied at checkout via /discount/QUIZ30 */
      return { i: i, p: p, r: r, c: c, full: full, paid: Math.min(paid, full) };
    });
    var plan = lines.reduce(function (t, x) { return t + x.full; }, 0);
    var paid = lines.reduce(function (t, x) { return t + x.paid; }, 0);
    var snack = C.snacks.reduce(function (t, x) { return t + (S.snacks[x.id] ? x.price : 0); }, 0);
    return { lines: lines, plan: plan, saved: plan - paid, snack: snack, total: paid + snack };
  }
  function viewOrder() {
    var O = C.o, A = C.a, nms = names(), multi = S.pups.length > 1, ot = orderTotals(), listN = joinNames(nms);
    var dv = { n: listN };
    var summary = ot.lines.map(function (x) {
      var v = { n: nms[x.i], pct: x.p.tier, recipe: x.r.name, grams: x.c.grams, bags: x.c.bags, cadence: x.c.cadence };
      return (multi ? '<small>' + esc(nms[x.i]) + '</small>' : '') + '<h3>' + esc(tok(O.line1, v)) + '</h3><p>' + esc(tok(O.line2, v)) + '</p>';
    }).join('');
    function row(label, val) { return '<div class="dd-nq__sum-row"><span>' + esc(label) + '</span><b>' + esc(val) + '</b></div>'; }
    var rows = (multi ? ot.lines.map(function (x) { return row(nms[x.i] + '’s ' + O.planLabel, money(x.full)); }).join('') : row(O.planLabel, money(ot.plan))) +
      C.snacks.filter(function (x) { return S.snacks[x.id]; }).map(function (x) { return row(x.name, money(x.price)); }).join('') +
      (ot.saved > 0.004 ? row(O.discountLabel, '−' + money(ot.saved)) : '') + (O.shippingValue ? row(O.shippingLabel, O.shippingValue) : '');
    var snacks = C.snacks.length ? '<div class="dd-nq__snacks2"><h3>' + esc(tok(O.snacksTitle, dv)) + '</h3><p>' +
      esc(O.snacksText || 'Single-ingredient treats from the same kitchens. Good for training, good for the walk home, good for the best boy ever.') + '</p><div class="dd-nq__snack-list">' + C.snacks.map(function (x) {
        var on = !!S.snacks[x.id];
        return '<div class="dd-nq__snack' + (on ? ' is-on' : '') + '">' + (x.img ? '<span class="dd-nq__snack-i"><img src="' + esc(x.img) + '" alt="" loading="lazy"></span>' : '') +
          '<span class="dd-nq__snack-t"><b>' + esc(x.name) + '</b><span>' + money(x.price) + '</span></span>' +
          '<button type="button" class="dd-nq__snack-l" data-snack="' + esc(x.id) + '" aria-pressed="' + on + '" aria-label="' + esc((on ? 'Remove ' : 'Add ') + x.name) + '">' + (on ? 'Remove' : 'Add') + '</button></div>';
      }).join('') + '</div><small>' + esc(O.snacksNote || 'Add or remove snacks any time. They ship with the next box, no extra shipping.') + '</small></div>' : '';
    var sum = '<div class="dd-nq__sum"><div class="dd-nq__sum-t"><small>Your order details:</small>' + summary + '</div><hr><div class="dd-nq__sum-rows">' + rows + '</div><hr>' +
      '<div class="dd-nq__sum-total"><span>' + esc(O.totalLabel) + '</span><b>' + money(ot.total) + '</b></div>' +
      '<button type="button" class="dd-nq__cta" data-checkout>' + esc(C.ctaLabel) + '</button>' +
      '<button type="button" class="dd-nq__sum-once" data-buyonce>Or buy once for ' + money(ot.plan) + ' + shipping</button>' +
      (O.note ? '<p class="dd-nq__sum-note">' + esc(String(O.note).replace(/\\n/g, '\n')) + '</p>' : '') + '<div class="dd-nq__err dd-nq__err--lt" data-nq-err2></div></div>';
    return '<div class="dd-nq__rtop">' + headHtml(tok(T.title, { n: listN }), '<button type="button" class="dd-nq__rlink" data-back-results>' + esc(O.backLabel) + '</button>') +
      '<div class="dd-nq__cart">' + snacks + sum + '</div></div>' + stripHtml();
  }

  function updateFoot() {
    var scr = S.screen, valid = !validate(), multi = S.pups.length > 1, P = S.pups[Math.min(S.active, S.pups.length - 1)];
    var label = { email: multi ? 'See their plans' : 'See ' + names()[0] + '’s Plan', results: C.t.inlineCta || 'Continue to my plan', order: C.ctaLabel }[scr] || 'Continue';
    cta.textContent = label;
    cta.classList.toggle('is-off', !valid);
    errEl.textContent = S.err;
    var e2 = $('[data-nq-err2]'); if (e2) e2.textContent = S.err;
    priceEl.hidden = scr !== 'results' && scr !== 'order';
    if (scr === 'order') {
      $('[data-nq-amt]').textContent = money(orderTotals().total);
      $('[data-nq-cap]').textContent = C.o.totalLabel;
    } else if (scr === 'results') {
      $('[data-nq-amt]').textContent = money(calc(P, P.tier).perDay) + '/day';
      $('[data-nq-cap]').textContent = (multi ? names()[S.active] + ' · ' : '') + P.tier + '% fresh';
    }
  }

  /* Klaviyo, once per completed quiz: profile properties, the quiz event, and (if a list is set) a consented list signup.
     S.sent holds the email + answers last sent, so re-renders, tier switches and reloads never send it twice. */
  function submitEmail() {
    var email = S.email.trim(), sig = email.toLowerCase() + '|' + JSON.stringify(S.pups.map(function (p) {
      return [p.name, p.years, p.months, p.sex, p.fixed, p.weight, p.body, p.energy, p.avoid, p.goals];
    }));
    if (sig === S.sent) return;
    S.sent = sig; persist();
    try {
      var profile = {}, pups = S.pups.map(function (p, i) {
        var c = calc(p, p.tier), tm = Math.round(Number(p.years || 0) * 12 + Number(p.months || 0));
        var d = { pup_name: pupName(p, i), age: Math.floor(tm / 12) + 'y' + (tm % 12) + 'm', sex: p.sex, fixed: p.fixed, weight: Number(p.weight), body: p.body, energy: p.energy,
          avoid: p.avoid, goals: p.goals, fresh_pct: p.tier, recipe: recipeFor(p).recipe.name, grams_per_day: c.grams,
          bags_per_month: Math.round(c.bags * 28 / c.days * 10) / 10, price_per_day: Math.round(c.perDay * 100) / 100, delivery_frequency: c.cadence };
        var k = 'Quiz Pup ' + (i + 1) + ' ';
        profile[k + 'Name'] = p.name; profile[k + 'Age'] = d.age; profile[k + 'Sex'] = p.sex; profile[k + 'Fixed'] = p.fixed;
        profile[k + 'Weight'] = p.weight; profile[k + 'Body'] = p.body; profile[k + 'Energy'] = p.energy;
        profile[k + 'Avoid'] = p.avoid.join(','); profile[k + 'Goals'] = p.goals.join(',');
        return d;
      });
      var props = Object.assign({}, pups[0], { pup_count: pups.length, pups: pups, promo_code: 'QUIZ30',
        results_url: location.origin + location.pathname + '?view=dd-new-quiz' });
      var api = function (path, body) {
        return fetch('https://a.klaviyo.com/client/' + path + '/?company_id=' + encodeURIComponent(C.klaviyoKey), {
          method: 'POST', headers: { 'Content-Type': 'application/vnd.api+json', revision: '2024-10-15' }, body: JSON.stringify({ data: body })
        }).catch(function () {});
      };
      /* identify ties this browser to the email for later onsite events; the event itself goes through the Client API */
      if (window.klaviyo && window.klaviyo.identify) window.klaviyo.identify({ email: email });
      if (C.klaviyoKey) {
        api('events', { type: 'event', attributes: { properties: props,
          metric: { data: { type: 'metric', attributes: { name: C.klaviyoEvent } } },
          profile: { data: { type: 'profile', attributes: { email: email, properties: profile } } } } });
      }
      if (C.klaviyoKey && C.klaviyoList) {
        api('subscriptions', { type: 'subscription', attributes: { custom_source: 'Quiz',
          profile: { data: { type: 'profile', attributes: { email: email, subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } } } } },
          relationships: { list: { data: { type: 'list', id: C.klaviyoList } } } });
      }
    } catch (e) {}
  }

  /* spinner on the checkout buttons while the cart is being set up; cleared on error and when the page is restored from the back button */
  function setBusy(on) {
    Array.prototype.forEach.call(root.querySelectorAll('[data-checkout],[data-buyonce],[data-nq-cta]'), function (b) { b.classList.toggle('is-busy', on); });
  }
  window.addEventListener('pageshow', function (e) { if (e.persisted) { S.adding = false; setBusy(false); } });

  function checkout(once) {
    var items = S.pups.map(function (p, i) {
      var r = recipeFor(p).recipe, c = calc(p, p.tier);
      var it = { id: r.variant, quantity: c.bags, properties: { Pup: pupName(p, i), 'Fresh %': p.tier + '%', 'Grams per day': String(c.grams) } };
      if (c.plan && !once) it.selling_plan = c.plan;
      return it;
    });
    C.snacks.forEach(function (x) {
      if (!S.snacks[x.id]) return;
      var it = { id: x.variant, quantity: 1 };
      if (x.sellingPlan && !once) it.selling_plan = x.sellingPlan;
      items.push(it);
    });
    if (items.some(function (it) { return !it.id; })) {
      var first = recipeFor(S.pups[0]).recipe;
      if (items.length === 1 && first.url) { window.location.href = first.url; return; }
      S.err = 'This recipe isn\u2019t linked to a product yet.'; updateFoot(); return;
    }
    if (S.adding) return; /* ignore clicks while the cart request is in flight (no double-add); buttons stay visually active */
    S.adding = true;
    setBusy(true);
    /* empty the cart first so checkout only ever shows what the quiz built */
    fetch('/cart/clear.js', { method: 'POST', headers: { Accept: 'application/json' } })
      .then(function (res) { if (!res.ok) throw new Error(); return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) }); })
      .then(function (res) { if (!res.ok) throw new Error(); S.adding = false; window.location.href = once ? '/checkout' : '/discount/QUIZ30?redirect=' + encodeURIComponent('/checkout'); })
      .catch(function () {
        S.adding = false; setBusy(false);
        S.err = 'We couldn’t add that to your cart. Please try again.'; updateFoot();
        if (items.length === 1) window.location.href = recipeFor(S.pups[0]).recipe.url;
      });
  }

  function next() {
    if (S.screen === 'results') return go('order');
    if (S.screen === 'order') return checkout();
    var e = validate();
    if (e) { S.err = e; return updateFoot(); }
    if (S.screen === 'email') submitEmail();
    /* returning visitors who already gave an email skip that step */
    if (S.screen === 'goals' && EMAIL_RX.test(S.email.trim())) { submitEmail(); return go('loading'); }
    go(ORDER[ORDER.indexOf(S.screen) + 1]);
  }
  function back() {
    var map = { results: 'goals', email: 'goals' };
    if (S.screen === 'entry') return;
    go(map[S.screen] || ORDER[Math.max(0, ORDER.indexOf(S.screen) - 1)]);
  }
  function upd(i, patch) { Object.assign(S.pups[i], patch); S.err = ''; persist(); }

  /* ---- events ---- */
  cta.addEventListener('click', next);
  $('[data-nq-back]').addEventListener('click', back);
  body.addEventListener('keydown', function (e) { if (e.key === 'Enter' && e.target.tagName === 'INPUT') next(); });
  body.addEventListener('input', function (e) {
    var t = e.target;
    if (t.hasAttribute('data-name')) upd(+t.dataset.name, { name: t.value });
    else if (t.hasAttribute('data-f')) {
      var i = +t.dataset.i; upd(i, (function (o) { o[t.dataset.f] = t.value; return o; })({}));
    } else if (t.hasAttribute('data-email')) { S.email = t.value; S.err = ''; persist(); }
    else return;
    updateFoot();
  });
  body.addEventListener('click', function (e) {
    var b = e.target.closest('button'); if (!b || !body.contains(b)) return;
    if (b.hasAttribute('data-add')) { S.pups.push(clone(PUP)); persist(); render(); }
    else if (b.hasAttribute('data-rm')) { S.pups.splice(+b.dataset.rm, 1); S.active = 0; persist(); render(); }
    else if (b.hasAttribute('data-pick')) {
      var scr = S.screen, i = +b.dataset.i, id = b.dataset.pick, p = S.pups[i], patch = {};
      if (!MULTI[scr]) patch[scr] = id;
      else {
        var cur = p[scr];
        if (id === 'none') cur = cur.indexOf('none') > -1 ? [] : ['none'];
        else cur = cur.indexOf(id) > -1 ? cur.filter(function (x) { return x !== id; }) : cur.filter(function (x) { return x !== 'none'; }).concat(id);
        patch[scr] = cur;
      }
      upd(i, patch); render();
    }
    else if (b.hasAttribute('data-tab')) { S.active = +b.dataset.tab; S.swap = false; S.info = null; render(); }
    else if (b.hasAttribute('data-tip')) { S.tip = !S.tip; render(); }
    else if (b.hasAttribute('data-go-results')) { go('results'); }
    else if (b.hasAttribute('data-start')) { go('name'); }
    else if (b.hasAttribute('data-order')) { go('order'); }
    else if (b.hasAttribute('data-checkout')) { checkout(); }
    else if (b.hasAttribute('data-buyonce')) { checkout(true); }
    else if (b.hasAttribute('data-back-results')) { go('results'); }
    else if (b.hasAttribute('data-snack')) { S.snacks[b.dataset.snack] = !S.snacks[b.dataset.snack]; persist(); render(); }
    else if (b.hasAttribute('data-info')) { S.info = S.info === b.dataset.info ? null : b.dataset.info; render(); }
    else if (b.hasAttribute('data-swap')) { S.swap = !S.swap; render(); }
    else if (b.hasAttribute('data-recipe')) { upd(S.active, { recipe: b.dataset.recipe }); S.swap = false; render(); }
    else if (b.hasAttribute('data-tier')) { upd(S.active, { tier: +b.dataset.tier }); render(); }
  });

  /* the quiz footer is the last thing on the page: move it after the sections that follow this one (FAQ, videos, ...) */
  (function () {
    var sec = root.closest('.shopify-section');
    if (!sec || !sec.parentNode || !qfootEl) return;
    var tail = document.createElement('div');
    tail.className = 'dd-nq dd-nq--tail';
    sec.parentNode.appendChild(tail);
    tail.appendChild(qfootEl);
  })();
  document.addEventListener('click', function (e) {
    var a = e.target.closest ? e.target.closest('a[href="#nq-checkout"]') : null;
    if (!a) return;
    e.preventDefault();
    if (S.screen === 'results') go('order'); else if (S.screen === 'order') checkout();
  });

  render();
  if (S.screen === 'loading') startLoading();
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-dd-nq]').forEach(init);
  }
  initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
